module.exports = __webpack_public_path__ + "static/media/sidebar-1.40a696c4.png";